module.exports = __webpack_public_path__ + "static/media/boop_mag.76fac960.png";